<kc-labeled-tabs
  class="full-width"
  [tabs]="tabs"
  [selectedTabId]="selectedTabId()"
  (selectedTabChange)="onTabChange($event)"
>
  @switch (selectedTabId()) {
    @case ("utxos") {
      <app-utxos-summary />
    }
    @case ("krc20") {
      <app-krc20-summary />
    }
    @case ("krc721") {
      <app-krc721-summary />
    }
    @case ("kns") {
      <app-kns-summary />
    }
  }
</kc-labeled-tabs>
